import { BillingCycles } from '@/modules/common/rater/models/DXP/BillingCycles'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import {
  CommonProperty,
  Genders,
  HouseTypes
} from '@/modules/health/rater/models/DXP/ConfigurationsProperties'

export default class Configurations<MinMaxageType = any> {
  businessLine: string
  businessLineId: string
  maxInsurances: number
  maxDays: number
  isPymes?: boolean
  genders!: Genders
  billingCycles!: BillingCycles
  houseTypes!: HouseTypes
  hiringMaxAges?: MinMaxageType // init at child constructor

  constructor(data?: Configurations) {
    this.businessLine = data?.businessLine ?? ''
    this.businessLineId = data?.businessLineId ?? ''
    this.maxInsurances = Number(data?.maxInsurances) || 0
    this.maxDays = Number(data?.maxDays) || 0
    this.isPymes = data?.isPymes ?? false

    if (data?.genders) {
      this.genders = new Genders(data!.genders)
    }

    if (data?.billingCycles) {
      this.billingCycles = new BillingCycles(data!.billingCycles)
    }

    if (data?.houseTypes) {
      this.houseTypes = new HouseTypes(data!.houseTypes)
    }
  }

  parseToOptions(values: any) {
    if (!values) return []

    const options: CommonProperty[] = Object.values(values)
    return options
      .filter((option) => option)
      .map(({ text, id, disabled }) => ({
        label: text,
        value: id,
        disabled: !!disabled
      }))
  }
  getDefaultValue(values: any) {
    if (!values) return null
    const options: CommonProperty[] = Object.values(values)
    return options.filter((t) => t).find((t) => !!t.default)?.id ?? null
  }

  get genderOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.genders)
  }
  get defaultGender(): string | null {
    return this.getDefaultValue(this.genders)
  }

  get defaultBillingCycle(): string | null {
    return this.getDefaultValue(this.billingCycles)
  }

  get houseTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.houseTypes)
  }
  get defaultHouseType(): string | null {
    return this.getDefaultValue(this.houseTypes)
  }

  isEmpty() {
    return !this.businessLine || !this.businessLineId
  }
}
